import { CrmEndpointModuleConfig } from 'common-module/endpoint';

import { VERSION } from './version';

export const environment = {
  production: false,
  projectName: 'GATE',
  env: 'dev',
  version: VERSION,
  baseUrl: `https://api.admin.gate.touch4dev.net`,
  basicAuthToken: 'Z2F0ZTpYNm56bXhqVGY2SmJ1SEpjQUtDNQ==',
};

export const endpointModuleConfiguration: CrmEndpointModuleConfig = {
  endpoints: [
    {
      name: 'crm',
      baseUrl: environment.baseUrl,
      httpHeaders: {
        Authorization: `Basic ${environment.basicAuthToken}`,
      },
      withCredentials: true,
    },
  ],
};
